// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class RiskPlanDataKey {
    constructor() {
        this.Route = null;
        this.InstrumentGroupId = null;
        this.InstrumentId = null;
        this.ContractId = null;
        this.TradableId = null;
    }
}
